import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'containInArray',
  standalone: false,
})
export class ContainInArrayPipe implements PipeTransform {
  /**
   * Checks if a value exists in the provided array
   * @param value The value to check for
   * @param list Array to search in
   * @returns True if the value is in the array, false otherwise
   */
  transform(value: any, list?: any[]): boolean {
    if (!list || !list.length) {
      return false;
    }

    return list.includes(value);
  }
}
